import { PhoneNumberSchema } from "@redotech/redo-model/phone/phone-number";
import * as z from "zod";

export const getTeamPhoneNumber = {
  name: "getTeamPhoneNumber" as const,
  input: z.object({}),
  output: PhoneNumberSchema.nullable(),
};
